// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define([], ()=>{
const E = {};
E.intro = [['div',
    [['h1',
        [`Basic Technical Knowledge Center`],
        {className: `title`},
    ],
    ['p',
        [['b',
            [`Improvements? Suggestions?`],
        ],
        ` email `,
        ['a',
            [`dna@hola.org`],
            {href: `mailto:dna@hola.org`},
        ],
        ` `],
    ]],
    {className: `head`},
]];
E.data = [
    {
        id: 'rnd',
        title: `R&D developer`,
        tag: 'h2',
        short: `R&D developer`,
        html: [],
    },
    {
        id: 'rnd-read',
        title: `Reading materials`,
        tag: 'h3',
        html: [['ul',
            [['li',
                [`Read thoroughly the `,
                ['a',
                    [`Hola DNA`],
                    {href: `/dna`},
                ],
                `, and a peek at the `,
                ['a',
                    [`Hola dictionary`],
                    {href: `/dna/dict`},
                ]],
            ],
            ['li',
                [`Test yourself. Do the `,
                ['a',
                    [`DNA test`],
                    {href: `/dna/test`},
                ],
                `.`],
            ]],
        ]],
    },
    {
        id: 'rnd-unix',
        title: `Basic UNIX`,
        tag: 'h3',
        html: [['p',
            [` Practice the below items (excluding cvs), using this `,
            ['a',
                [`web-based Linux shell`],
                {href: `https://s-macke.github.io/jor1k/`},
            ],
            `. `],
        ],
        ['ul',
            [['li',
                [`bash`],
            ],
            ['ul',
                [['li',
                    [['a',
                        [`bash Basics`],
                        {href: `/dna/basics/bash`},
                    ]],
                ],
                ['li',
                    [['a',
                        [`bash cheat sheet`],
                        {href: `https://learncodethehardway.org/unix/bash_cheat_sheet.pdf`},
                    ],
                    ` `],
                ]],
            ],
            ['li',
                [`vi/vim/gvim`],
            ],
            ['ul',
                [['li',
                    [`vimtutor (run /usr/bin/vimtutor)`],
                ],
                ['li',
                    [['a',
                        [`gvim`],
                        {href: `/dna/basics/vi`},
                    ]],
                ]],
            ],
            ['li',
                [`tar/gz/patch (`,
                ['a',
                    [`zip_and_patch`],
                    {href: `/dna/basics/gzip`},
                ],
                `)`],
            ],
            ['li',
                [`Regular expressions (man 7 regex)`],
            ],
            ['li',
                [` grep & sed (`,
                ['a',
                    [`Sed & Awk`],
                    {href: `http://www.unix.com.ua/orelly/unix2.1/sedawk/index.htm`},
                ],
                ` chapter 2) `],
            ],
            ['li',
                [`cvs ("Basic Info" section only from `,
                ['a',
                    [`cvs_info`],
                    {href: `/dna/basics/cvs#basic`},
                ],
                `)`],
            ]],
        ]],
    },
    {
        id: 'rnd-js',
        title: `JS Language`,
        tag: 'h3',
        short: `JS Language`,
        html: [['ul',
            [['li',
                [` These 3 pages discuss EXACTLY how JavaScript works
                    internally. Know this perfectly, so your understanding
                    of scoping, stacks, variables, context, closures,
                    object&arrays, functions 100% accurate. We strongly
                    suggest reading these articles a few times, ensuring
                    complete understanding of JS core. `],
            ],
            ['ul',
                [['li',
                    [` original url: https://howtonode.org/object-graphs `,
                    ` `,
                    ['a',
                        [` Learning Javascript with Object Graphs `],
                        {href: `http://web.archive.org/web/20161227031529/http://howtonode.org/object-graphs`},
                    ],
                    ` `],
                ],
                ['li',
                    [` original url: https://howtonode.org/object-graphs-2 `,
                    ` `,
                    ['a',
                        [` Learning Javascript with Object Graphs (Part II) `],
                        {href: `http://web.archive.org/web/20161227031529/http://howtonode.org/object-graphs-2`},
                    ],
                    ` `],
                ],
                ['li',
                    [` original url: https://howtonode.org/object-graphs-3 `,
                    ` `,
                    ['a',
                        [` Learning Javascript with Object Graphs (Part III)
                            `],
                        {href: `http://web.archive.org/web/20161227031529/http://howtonode.org/object-graphs-3`},
                    ],
                    ` `],
                ]],
            ],
            ['li',
                [`Types conversions`],
            ],
            ['ul',
                [['li',
                    [['a',
                        [` Type conversion table`],
                        {href: `http://jibbering.com/faq/notes/type-conversion`},
                    ]],
                ]],
            ],
            ['li',
                [`Once you feel you are strong on the two core JS items
                    above, go through this list of quirks to validate you
                    really know it all: `,
                ['a',
                    [`Javascript quirks`],
                    {href: `http://bonsaiden.github.io/JavaScript-Garden/`},
                ],
                ` `],
            ],
            ['li',
                [`The new `,
                ['a',
                    [`ES6 features`],
                    {href: `https://github.com/lukehoban/es6features`},
                ],
                ` `],
            ],
            ['li',
                [`NodeJS: `,
                ['a',
                    [` an absolute beginner's intro`],
                    {href: `https://blog.codeship.com/node-js-tutorial/`},
                ]],
            ],
            ['li',
                [`Hola's `,
                ['a',
                    [`JS Coding conventions`],
                    {href: `/dna/js_code`},
                ]],
            ]],
        ]],
    },
    {
        id: 'rnd-html_css',
        title: `HTML5/CSS3`,
        tag: 'h3',
        short: `HTML5/CSS3`,
        html: [['ul',
            [['li',
                [` This might sound terribly basic, but these short videos
                    from Google University are helpful in a understanding
                    how to nicely separate code, and avoid spaghetti:`,
                ['br'],
                ['a',
                    [` Google HTML/CSS/Javascript from the Ground Up Class:
                        Introduction `],
                    {href: `http://www.youtube.com/watch?v=60O1CJqh8IM&list=PLDE314C0C8581E8BA`},
                ],
                ` (No need to watch the JS videos) `],
            ],
            ['li',
                [` A great, advanced and interesting presentation: GRITS game
                    (also talks about JS):`,
                ['br'],
                ['a',
                    [` Google I/O 2012 - GRITS: PvP Gaming with HTML5 `],
                    {href: `http://www.youtube.com/watch?v=Prkyd5n0P7k`},
                ],
                ` `],
            ],
            ['li',
                [` The web can do that?:`,
                ['br'],
                ['a',
                    [` Google I/O 2012 - The Web Can Do That!? `],
                    {href: `http://www.youtube.com/watch?v=X_ek1wSe66o`},
                ],
                ` `],
            ],
            ['li',
                [` Web tooling:`,
                ['br'],
                ['a',
                    [` Google I/O 2012 - Better Web App Development Through
                        Tooling `],
                    {href: `http://www.youtube.com/watch?v=Mk-tFn2Ix6g`},
                ],
                ` `],
            ]],
        ]],
    },
    {
        id: 'rnd-react',
        title: `ReactJS`,
        tag: 'h3',
        short: `ReactJS`,
        html: [['ul',
            [['li',
                [` Go through `,
                ['a',
                    [` ReactJS tutorial`],
                    {href: `https://reactjs.org/tutorial/tutorial.html`},
                ],
                ` `],
            ]],
        ]],
    },
    {
        id: 'rnd-jquery',
        title: `jQuery`,
        tag: 'h3',
        short: `jQuery`,
        html: [['ul',
            [['li',
                [` Read DataTables' source code, it's not short, but one of
                    the nicest pieces of code; very objected oriented,
                    highly extensible and programmable.`,
                ['br'],
                ` Line-by-line reading will advance your understanding of
                    how good jQuery plugin code should be written, how it
                    should be used, and how to write real world generic
                    object oriented code `],
            ]],
        ]],
    },
    {
        id: 'pm',
        title: `Project manager`,
        tag: 'h2',
        short: `Project manager`,
        html: [],
    },
    {
        id: 'pm-unix',
        title: `Basic UNIX`,
        tag: 'h3',
        html: [['p',
            [` Practice Bash and VI using this `,
            ['a',
                [`web-based Linux shell`],
                {href: `http://bellard.org/jslinux/`},
            ],
            `. `],
        ],
        ['ul',
            [['li',
                [['a',
                    [`Basic UNIX`],
                    {href: `http://www.physics.louisville.edu/williger/Astronomybootcamp/Unix_tutorials/Tenminuteunix/tenminuteunix.pdf`},
                ],
                ` `],
            ],
            ['li',
                [['a',
                    [`bash Basics`],
                    {href: `/dna/basics/bash`},
                ]],
            ],
            ['li',
                [['a',
                    [`VI ("Minimal" section only)`],
                    {href: `/dna/basics/vi#minimal`},
                ]],
            ],
            ['li',
                [['a',
                    [`cvs ("Minimal Info" section only)`],
                    {href: `/dna/basics/cvs#minimal`},
                ]],
            ]],
        ]],
    },
    {
        id: 'pm-html_css',
        title: `Basic HTML/CSS`,
        tag: 'h3',
        short: `HTML/CSS`,
        html: [['ul',
            [['li',
                [` Although quite long, if you are not familiar with
                    HTML/CSS, or if you need refreshment, this `,
                ['a',
                    [`HTML and CSS Tutorial`],
                    {href: `https://www.youtube.com/watch?v=y3UH2gAhwPI`},
                ],
                ` provides the basics; how to build a web page and how to
                    design it using simple CSS. `],
            ],
            ['li',
                [` A More in-depth `,
                ['a',
                    [`HTML and CSS tutorial for beginners`],
                    {href: `https://www.youtube.com/watch?v=mzlqjRYszoI&index=1&list=PLEAFE1C118B3ED6AE`},
                ],
                ` (contains 47 short videos). `],
            ]],
        ]],
    },
    {
        id: 'pm-read',
        title: `Reading materials`,
        tag: 'h3',
        html: [['ul',
            [['li',
                [`Read thoroughly the `,
                ['a',
                    [`Hola DNA`],
                    {href: `/dna`},
                ],
                ` and the `,
                ['a',
                    [`Hola dictionary`],
                    {href: `/dna/dict`},
                ]],
            ],
            ['li',
                [`Test yourself. Do the `,
                ['a',
                    [`DNA test`],
                    {href: `/dna/test`},
                ],
                `.`],
            ],
            ['li',
                [` Watch `,
                ['a',
                    [`Eric Ries talks about the "Lean Startup" at Google`],
                    {href: `https://www.youtube.com/watch?v=fEvKo90qBns`},
                ],
                `. ("The Lean Startup" book, by Eric Ries, exists in our
                    library. It is recommended to read it cover-to-cover
                    once you started at Hola) `],
            ]],
        ]],
    },
    {
        id: 'pm-prod',
        title: `Hola products knowledge`,
        tag: 'h3',
        html: [['ul',
            [['li',
                [`Watch the `,
                ['a',
                    [`Hola introduction video`],
                    {href: `https://drive.google.com/open?id=0B2dOJIilWt9USWtZMVBHNnhUdUk`},
                ],
                ` `],
            ],
            ['li',
                [`Review the `,
                ['a',
                    [`Hola product lines`],
                    {href: `/dna/dict#products`},
                ]],
            ]],
        ]],
    },
    {
        id: 'graphic',
        title: `Graphic designer`,
        tag: 'h2',
        short: `Graphic designer`,
        html: [],
    },
    {
        id: 'graphic-unix',
        title: `Basic UNIX`,
        tag: 'h3',
        html: [['p',
            [` You should practice Bash and VI using this `,
            ['a',
                [`web-based Linux shell`],
                {href: `http://bellard.org/jslinux/`},
            ],
            `. `],
        ],
        ['ul',
            [['li',
                [['a',
                    [`Basic UNIX`],
                    {href: `http://mally.stanford.edu/~sr/computing/basic-unix.html`},
                ],
                ` `],
            ],
            ['li',
                [['a',
                    [`bash Basics`],
                    {href: `/dna/basics/bash`},
                ]],
            ],
            ['li',
                [['a',
                    [`VI ("Minimal" section only)`],
                    {href: `/dna/basics/vi#minimal`},
                ]],
            ],
            ['li',
                [['a',
                    [`cvs ("Minimal Info" section only)`],
                    {href: `/dna/basics/cvs#minimal`},
                ]],
            ]],
        ]],
    },
    {
        id: 'graphic-adobe',
        title: `Adobe products`,
        tag: 'h3',
        short: `Adobe products`,
        html: [['ul',
            [['li',
                [['a',
                    [`Illustrator`],
                    {href: `http://tastytuts.com/emailer/illustrator_beginners/illustrator_for_beginners_tastytuts.pdf`},
                ]],
            ],
            ['li',
                [['a',
                    [`Photoshop`],
                    {href: `http://tastytuts.com/emailer/photoshop_beginners/photoshop_for_beginners_tastytuts.pdf`},
                ]],
            ],
            ['li',
                [['a',
                    [`InDesign`],
                    {href: `http://help.adobe.com/archive/en/indesign/cs6/indesign_reference.pdf`},
                ]],
            ],
            ['li',
                [['a',
                    [`After Effects`],
                    {href: `http://cgi.tutsplus.com/tutorials/after-effects-for-beginners-getting-started--ae-195`},
                ]],
            ]],
        ]],
    },
    {
        id: 'graphic-hola',
        title: `Hola products knowledge`,
        tag: 'h3',
        html: [['ul',
            [['li',
                [`Watch the `,
                ['a',
                    [`Hola introduction video`],
                    {href: `https://drive.google.com/open?id=0B2dOJIilWt9USWtZMVBHNnhUdUk`},
                ],
                ` `],
            ],
            ['li',
                [`Review the `,
                ['a',
                    [`Hola product lines`],
                    {href: `/dna/dict#products`},
                ]],
            ]],
        ]],
    },
    {
        id: 'deploy',
        title: `Deploy engineer`,
        tag: 'h2',
        short: `Deploy`,
        html: [],
    },
    {
        id: 'deploy-unix',
        title: `Basic UNIX`,
        tag: 'h3',
        html: [['p',
            [` You should practice Bash and VI using this `,
            ['a',
                [`web-based Linux shell`],
                {href: `http://bellard.org/jslinux/`},
            ],
            `. `],
        ],
        ['ul',
            [['li',
                [['a',
                    [`Basic UNIX`],
                    {href: `http://www.physics.louisville.edu/williger/Astronomybootcamp/Unix_tutorials/Tenminuteunix/tenminuteunix.pdf`},
                ],
                ` `],
            ],
            ['li',
                [['a',
                    [`bash Basics`],
                    {href: `/dna/basics/bash`},
                ]],
            ],
            ['li',
                [['a',
                    [`VI ("Minimal" section only)`],
                    {href: `/dna/basics/vi#minimal`},
                ]],
            ],
            ['li',
                [['a',
                    [`cvs ("Minimal Info" section only)`],
                    {href: `/dna/basics/cvs#minimal`},
                ]],
            ]],
        ]],
    },
    {
        id: 'zs-deploy-hola',
        title: `Hola products knowledge`,
        tag: 'h3',
        html: [['ul',
            [['li',
                [`Watch the `,
                ['a',
                    [`Hola introduction video`],
                    {href: `https://drive.google.com/open?id=0B2dOJIilWt9USWtZMVBHNnhUdUk`},
                ],
                ` `],
            ],
            ['li',
                [`Review the `,
                ['a',
                    [`Hola product lines`],
                    {href: `/dna/dict#products`},
                ]],
            ],
            ['li',
                [`Get familiar specifically with the Hola by installing
                    it for the below browsers:`],
            ],
            ['ul',
                [['li',
                    [`Hola for Chrome`],
                ],
                ['li',
                    [`Hola for Firefox`],
                ],
                ['li',
                    [`Hola for Android or iPhone`],
                ]],
            ]],
        ]],
    },
    {
        id: 'deploy-read',
        title: `Reading materials`,
        tag: 'h3',
        html: [['ul',
            [['li',
                [` Read the `,
                ['a',
                    [`Instant messaging communication guide`],
                    {href: `/dna/comm#im`},
                ],
                ` `],
            ]],
        ]],
    },
    {
        id: 'content',
        title: `Content manager`,
        tag: 'h2',
        html: [],
    },
    {
        id: 'content-unix',
        title: `Basic UNIX`,
        tag: 'h3',
        html: [['p',
            [` Practice Bash and VI using this `,
            ['a',
                [`web-based Linux shell`],
                {href: `http://bellard.org/jslinux/`},
            ],
            `. `],
        ],
        ['ul',
            [['li',
                [['a',
                    [`Basic UNIX`],
                    {href: `http://mally.stanford.edu/~sr/computing/basic-unix.html`},
                ],
                ` `],
            ],
            ['li',
                [['a',
                    [`bash Basics`],
                    {href: `/dna/basics/bash`},
                ]],
            ],
            ['li',
                [['a',
                    [`VI ("Minimal" section only)`],
                    {href: `/dna/basics/vi#minimal`},
                ]],
            ],
            ['li',
                [['a',
                    [`cvs ("Minimal Info" section only)`],
                    {href: `/dna/basics/cvs#minimal`},
                ]],
            ]],
        ]],
    },
    {
        id: 'content-html_css',
        title: `Basic HTML/CSS`,
        tag: 'h3',
        short: `HTML/CSS`,
        html: [['ul',
            [['li',
                [` Although quite long, if you are not familiar with
                    HTML/CSS, or if you need refreshment, this `,
                ['a',
                    [`HTML and CSS Tutorial`],
                    {href: `https://www.youtube.com/watch?v=y3UH2gAhwPI`},
                ],
                ` provides the basics; how to build a web page and how to
                    design it using simple CSS. `],
            ],
            ['li',
                [` More thorough `,
                ['a',
                    [`HTML and CSS tutorial for beginners`],
                    {href: `https://www.youtube.com/watch?v=mzlqjRYszoI&index=1&list=PLEAFE1C118B3ED6AE`},
                ],
                ` (contains 47 short videos). `],
            ]],
        ]],
    },
    {
        id: 'content-read',
        title: `Reading materials`,
        tag: 'h3',
        html: [['ul',
            [['li',
                [`Read thoroughly the `,
                ['a',
                    [`Hola DNA`],
                    {href: `/dna`},
                ],
                ` and the `,
                ['a',
                    [`Hola dictionary`],
                    {href: `/dna/dict`},
                ]],
            ],
            ['li',
                [`Test yourself. Do the `,
                ['a',
                    [`DNA test`],
                    {href: `/dna/test`},
                ],
                `.`],
            ],
            ['li',
                [` Watch `,
                ['a',
                    [`Eric Ries talks about the "Lean Startup" at Google`],
                    {href: `https://www.youtube.com/watch?v=fEvKo90qBns`},
                ],
                `. ("The Lean Startup" book, by Eric Ries, exists in our
                    library. It is recommended to read it cover-to-cover
                    once you started at Hola) `],
            ]],
        ]],
    },
    {
        id: 'content-prod',
        title: `Hola products knowledge`,
        tag: 'h3',
        html: [['ul',
            [['li',
                [`Watch the `,
                ['a',
                    [`Hola introduction video`],
                    {href: `https://drive.google.com/open?id=0B2dOJIilWt9USWtZMVBHNnhUdUk`},
                ],
                ` `],
            ],
            ['li',
                [`Review the `,
                ['a',
                    [`Hola product lines`],
                    {href: `/dna/dict#products`},
                ]],
            ]],
        ]],
    },
    {
        id: 'marketing',
        title: `Performance Marketing`,
        tag: 'h2',
        short: `Performance Marketing`,
        html: [],
    },
    {
        id: 'marketing-general',
        title: `General Knowledge`,
        tag: 'h3',
        html: [],
    },
    {
        id: 'marketing-general-hola',
        title: `Hola products knowledge`,
        tag: 'h4',
        html: [['ul',
            [['li',
                [`Watch the `,
                ['a',
                    [`Hola introduction video`],
                    {href: `https://drive.google.com/open?id=0B2dOJIilWt9USWtZMVBHNnhUdUk`},
                ],
                ` `],
            ],
            ['li',
                [`Review the `,
                ['a',
                    [`Hola product lines`],
                    {href: `/dna/dict#products`},
                ]],
            ]],
        ]],
    },
    {
        id: 'marketing-general-read',
        title: `Reading materials`,
        tag: 'h4',
        html: [['ul',
            [['li',
                [`Read thoroughly the `,
                ['a',
                    [`Hola DNA`],
                    {href: `/dna`},
                ],
                ` and the `,
                ['a',
                    [`Hola dictionary`],
                    {href: `/dna/dict`},
                ]],
            ],
            ['li',
                [`Test yourself. Do the `,
                ['a',
                    [`DNA test`],
                    {href: `/dna/test`},
                ],
                `.`],
            ],
            ['li',
                [` Watch `,
                ['a',
                    [`Eric Ries talks about the "Lean Startup" at Google`],
                    {href: `https://www.youtube.com/watch?v=fEvKo90qBns`},
                ],
                `. ("The Lean Startup" book, by Eric Ries, exists in our
                    library. It is recommended to read it cover-to-cover
                    once you started at Hola) `],
            ]],
        ]],
    },
    {
        id: 'marketing-unix',
        title: `Basic UNIX`,
        tag: 'h3',
        html: [['p',
            [` Practice Bash and VI using this `,
            ['a',
                [`web-based Linux shell`],
                {href: `http://bellard.org/jslinux/`},
            ],
            `. `],
        ],
        ['ul',
            [['li',
                [['a',
                    [`Basic UNIX`],
                    {href: `http://mally.stanford.edu/~sr/computing/basic-unix.html`},
                ],
                ` `],
            ],
            ['li',
                [['a',
                    [`bash Basics`],
                    {href: `/dna/basics/bash`},
                ]],
            ],
            ['li',
                [['a',
                    [`VI ("Minimal" section only)`],
                    {href: `/dna/basics/vi#minimal`},
                ]],
            ],
            ['li',
                [['a',
                    [`cvs ("Minimal Info" section only)`],
                    {href: `/dna/basics/cvs#minimal`},
                ]],
            ]],
        ]],
    },
    {
        id: 'marketing-html_css',
        title: `Basic HTML/CSS`,
        tag: 'h3',
        short: `HTML/CSS`,
        html: [['ul',
            [['li',
                [` Although quite long, if you are not familiar with
                    HTML/CSS, or if you need refreshment, this `,
                ['a',
                    [`HTML and CSS Tutorial`],
                    {href: `https://www.youtube.com/watch?v=y3UH2gAhwPI`},
                ],
                ` provides the basics; how to build a web page and how to
                    design it using simple CSS. `],
            ],
            ['li',
                [` More thorough `,
                ['a',
                    [`HTML and CSS tutorial for beginners`],
                    {href: `https://www.youtube.com/watch?v=mzlqjRYszoI&index=1&list=PLEAFE1C118B3ED6AE`},
                ],
                ` (contains 47 short videos). `],
            ]],
        ]],
    },
];
return E;
});
